<template>
    <div class="feedbackboard-phonetic-vowel">
        <div class="feedbackboard-phonetic-vowel__feature-type">
            <span class="feedbackboard-phonetic-vowel__feature-label">DEĞİŞKE ÖZELLİĞİ</span>
            <div class="feedbackboard-phonetic-vowel__feature-options">
                <BtnOptionFeedback
                    :class="{
                        'btn-option-feedback--skipped': feedbackVariant.answerValue === ''
                    }"
                    :optionText="$t('vowel.variant.' + feedbackVariant.correctValue)" />
                <BtnOptionFeedback
                    v-if="feedbackVariant.correctValue !== feedbackVariant.answerValue
                        && feedbackVariant.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('vowel.variant.' + feedbackVariant.answerValue)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionFeedback from '@/components/BtnOptionFeedback.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionFeedback,
        },

        computed: {
            feedbackVariant(){
                return this.$store.state.feedbackData.variant;
            }
        }
    };
</script>

<style scoped src="@/css/components/feedbackboard-phonetic-vowel.css"></style>